import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "./index.scss";
import Formula3DPreview from "../../../FormulaGenerator/Formula3DPreview";
import LowSinusLIcon from "./images/LowSinusL.png";
import LowSinusRIcon from "./images/LowSinusR.png";
import LowSinusBothIcon from "./images/LowSinusBoth.png";
import SinusClearIcon from "./images/NormalSinus.png";
import SelectionTypeList from "../../SelectionTypeList";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const BRLowSinus = ({
  stepId,
  setNextKeyPrefix,
  currentChoice,
  toggleNextBtnState
}) => {
  const {
    _t
  } = useTranslation();
  const {
    dentalData,
    setStepFormula
  } = useContext(StepContext);
  const availableTypes = useMemo(() => {
    return [{
      key: "lowSinusesRight",
      img: LowSinusRIcon,
      name: _t("Тонкая кость справа")
    }, {
      key: "lowSinusesLeft",
      img: LowSinusLIcon,
      name: _t("Тонкая кость слева")
    }, {
      key: "lowSinusesBoth",
      img: LowSinusBothIcon,
      name: _t("Тонкая кость с обоих сторон")
    }, {
      key: "removeSelection",
      img: SinusClearIcon,
      name: _t("Убрать выделенное")
    }];
  }, [_t]);
  const runOnce = useRef(false);
  useEffect(() => {
    if (!runOnce.current) {
      if (!currentChoice || !currentChoice.hasOwnProperty("formula") || !currentChoice.formula.hasOwnProperty("sinuses") || !currentChoice.formula.sinuses.length) {
        const updatedData = { ...currentChoice.formula,
          sinuses: ["normalSinusesLeft", "normalSinusesRight"]
        };
        setStepFormula(stepId, updatedData);
        runOnce.current = true;
      }
    }
  }, [currentChoice, setNextKeyPrefix, stepId, toggleNextBtnState]);
  const [isFormulaLoaded, setIsFormulaLoaded] = useState(false);

  function formulaLoadedCallback() {
    setIsFormulaLoaded(true);
  }

  const [selected, setSelected] = useState("");

  function setData(key) {
    if (!isFormulaLoaded) {
      return;
    }

    setSelected(key === "removeSelection" ? "" : key);
    let updatedData = {};
    let sinusData = dentalData?.sinuses ? dentalData.sinuses.filter(el => !["normalSinusesLeft", "normalSinusesRight", "lowSinusesLeft", "lowSinusesRight"].includes(el)) : [];

    switch (key) {
      case "lowSinusesLeft":
        updatedData = { ...dentalData,
          sinuses: [...sinusData, "normalSinusesRight", "lowSinusesLeft"]
        };
        break;

      case "lowSinusesRight":
        updatedData = { ...dentalData,
          sinuses: [...sinusData, "normalSinusesLeft", "lowSinusesRight"]
        };
        break;

      case "lowSinusesBoth":
        updatedData = { ...dentalData,
          sinuses: [...sinusData, "lowSinusesLeft", "lowSinusesRight"]
        };
        break;

      case "removeSelection":
        updatedData = {
          sinuses: [...sinusData, "normalSinusesLeft", "normalSinusesRight"]
        };
        break;

      default:
        break;
    }

    setStepFormula(stepId, updatedData);
    toggleNextBtnState(false);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "brLowSinus"
  }, /*#__PURE__*/React.createElement("div", {
    className: "brLowSinus-types"
  }, /*#__PURE__*/React.createElement("p", null, _t("Выберите ниже")), /*#__PURE__*/React.createElement(SelectionTypeList, {
    types: availableTypes,
    selected: selected,
    setData: setData,
    columns: 2,
    disable: !isFormulaLoaded
  })), /*#__PURE__*/React.createElement("div", {
    className: "brLowSinus-container"
  }, /*#__PURE__*/React.createElement(Formula3DPreview, {
    stlPack: dentalData,
    availableSwitchers: ["softTissue", "skull", "prosthesisAll"],
    hideNotUsedSides: false,
    onLoaded: formulaLoadedCallback
  })));
};

export default BRLowSinus;